import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import Button from '@omilia/button';

// @ts-ignore
import { getUser } from 'store/services/session/selectors';

import {
  SIconImage,
  SErrorInfoContainer,
  SErrorH1,
  SErrorSubtitle,
  SEmailText,
  FixStyle,
} from 'components/styled';

import ErrorLayout from 'components/ErrorLayout';

interface StateProps {
  user: any;
}

const NoAccess = ({ user }: StateProps) => (
  <ErrorLayout>
    <Helmet>
      <title>No access permission</title>
    </Helmet>

    <SIconImage glyph="error-403" size="96" />

    <SErrorInfoContainer>
      <SErrorH1>You need permission</SErrorH1>
      <SErrorSubtitle level={1}>
        {`Sorry, you have no access permission.
        Ask the owner for access, or switch to an other account with permission. 
        
        You are signed in as `}
        <SEmailText>{user.email}</SEmailText>
      </SErrorSubtitle>
    </SErrorInfoContainer>

    <Link to="/">
      <FixStyle />
      <Button color="primary" variant="contained">
        Return back
      </Button>
    </Link>
  </ErrorLayout>
);

const mapStateToProps = (state: any) => ({
  user: getUser(state),
});

export default connect(mapStateToProps)(NoAccess);
